"use strict";
angular.module("core").directive("indeterminate", function() {
    return {
        restrict: "A",
        link: function(scope, elem, attr) {
            scope.$watch(attr.indeterminate, function(value) {
                elem[0].indeterminate = value;
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/indeterminate/indeterminate.directive.js
// module id = 609
// module chunks = 0